import script from "./createGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./createGroup.vue?vue&type=script&lang=ts&setup=true"

import "./createGroup.vue?vue&type=style&index=0&id=4dea6e16&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dea6e16"]])

export default __exports__